"use client";
import constate from "constate";
import { useState } from "react";

function useRfqStore() {
  const [open, setOpen] = useState(false);
  const [quotes, setQuotes] = useState([]);
  const [shipments, setShipments] = useState([]);
  const request = {
    commercialInvoice: "",
    packingList: "",
    billOfLanding: "",
    originPort: "",
    destinationPort: "",
    shipmentTye: "",
    shipmentMode: "",
    commodityInfo: [
      {
        name: "",
        packageType: "",
        packageQuantity: "",
        packageWeight: "",
        cargoValue: "",
      },
    ],
    shippingInfo: {
      numberOfContainers: 3,
      containerSize: "",
      containerType: "",
    },
    serviceInfo: {
      preferredFreightForwarder: "",
      insurancePolicyType: "",
    },
  };

  return {
    open,
    setOpen,
    request,
    quotes,
    setQuotes,
    shipments,
    setShipments,
  };
}

export const [RfqProvider, useRfqContext] = constate(useRfqStore);
